export const fontSizes = [
  '4px',
  '5px',
  '6px',
  '7px',
  '8px',
  '9px',
  '10px',
  '11px',
  '12px',
  '13px',
  '14px',
  '15px',
  '16px',
  '17px',
  '18px',
  '19px',
  '20px',
  '21px',
  '22px',
  '23px',
  '24px',
  '25px',
  '26px',
  '27px',
  '28px',
  '29px',
  '30px',
  '31px',
  '32px',
  '33px',
  '34px',
  '35px',
  '36px',
]
export const borderStrokeWidthSizes = [
  '0px',
  '1px',
  '2px',
  '3px',
  '4px',
  '5px',
  '6px',
  '7px',
  '9px',
  '10px',
  '11px',
  '12px',
  '13px',
  '14px',
  '15px',
  '16px',
  '17px',
  '18px',
  '19px',
  '20px',
  '21px',
]
export const fontWeights = ['200', '400', '600']

export const cardOrientations = ['vertical', 'horizontal']

export const productDummyData = {
  badges: [
    {
      displayName: 'Vendor Insights',
      value: 'VENDOR_INSIGHTS',
    },
  ],
  short_description: 'Your short description appears here.',
  product_url: '',
  reviews: [
    {
      averageCustomerRating: '0',
      provider: 'AWS_MARKETPLACE',
      count: '0',
      url: 'https://aws.amazon.com/marketplace/reviews/reviews-list/prodview-3fqzxq4nazmgu',
    },
    {
      averageCustomerRating: '1',
      provider: 'G2',
      count: '0',
      url: 'https://www.g2.com/products/thoropass/reviews',
    },
  ],
  logo_url: 'https://assets.flyout.labra.io/misc/logo_here.png',
  long_description:
    'As companies continue to move to the cloud, new threats bring additional challenges to cyberdefense. Security teams face evolving requirements for tracking and protecting data across cloud environments.\n\nProduct Options\nTrellix Cloudvisory - Secure your multicloud and container environments with end-to-end visibility, security compliance monitoring, and automatic in-line governance.\nTrellix Detection As A Service - Identify malware using flexible file and content scanning and the latest threat intelligence to protect your entire cloud infrastructure.\nTrellix Cloud Workload Security - Secure all your hybrid cloud infrastructure workloads.\n\nBefore purchasing, please contact aws@trellix.com. Your account team will assist in providing an AWS Private Offer with accurate SKUs, quantities, and qualified discounts.',
  buy_with_aws_url: '',
  title: 'Your headline goes here',
}

export const productDummyDataForListing = {
  badges: [],
  short_description: 'Short description',
  product_url: 'https://aws.amazon.com/marketplace/pp/prodview-ykasbrn7lnma2',
  reviews: null,
  logo_url:
    'https://d7umqicpi7263.cloudfront.net/img/product/32650a88-f424-400d-8fb0-586e1b715646.com/a808e9b2092cc4b7cb111b5764ad0147',
  long_description: 'Long description',
  buy_with_aws_url:
    'https://aws.amazon.com/marketplace/procurement?productId=prod-edpuwvnqltjl4&sellerId=seller-ixnylfvhjm6eq&isBuyWithAWS=true',
  title: 'Test contract product',
}

export const fontNames = [
  'sans-serif',
  'Roboto',
  'Poppins',
  'Times New Roman',
  'Montserrat',
  'Nunito Sans',
  'Helvetica',
  'Raleway',
  'Arial',
  'Georgia',
  'other',
]
export const buttonNames = [
  {
    label: 'Buy with AWS',
    value: 'buy_with_aws',
  },
  {
    label: 'View on AWS Marketplace',
    value: 'open_listing',
  },
  {
    label: 'Request a private offer',
    value: 'request_private_offer',
  },
  {
    label: 'Request demo',
    value: 'request_demo',
  },
  {
    label: 'Try for free',
    value: 'free_trial',
  },
]
